// src/services/GeocodingService.js

/**
 * Convert address to geographic coordinates using OpenStreetMap Nominatim API
 * This is free and doesn't require an API key
 * 
 * @param {string} address - The address to geocode
 * @returns {Promise<Object>} - Promise resolving to {lat, lng} coordinates
 */
export const geocodeAddress = async (address) => {
  try {
    // Encode the address for URL
    const encodedAddress = encodeURIComponent(address);
    
    // Use OpenStreetMap's Nominatim API for geocoding
    const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodedAddress}&limit=1`);
    
    if (!response.ok) {
      throw new Error(`Geocoding failed with status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Check if we got results
    if (!data || data.length === 0) {
      throw new Error('No results found for this address');
    }
    
    // Return the coordinates
    return {
      lat: parseFloat(data[0].lat),
      lng: parseFloat(data[0].lon)
    };
  } catch (error) {
    console.error("Error geocoding address:", error);
    throw error;
  }
};